import { render, staticRenderFns } from "./DeliveryNoteStatusRenderer.vue?vue&type=template&id=72319dbc&lang=pug&"
import script from "./DeliveryNoteStatusRenderer.vue?vue&type=script&lang=ts&"
export * from "./DeliveryNoteStatusRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryNoteStatusRenderer.vue?vue&type=style&index=0&id=72319dbc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports